<template>
    <el-row class="grid-stack-item">
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <div class="header">
                <h1>{{ $t('General Settings') }}</h1>
            </div>

            <div class="my-content">
                <div class="grid-stack-item-content">
                    <el-form :label-position="labelPosition" :model="generalSettings" :rules="rules" ref="generalSettings">
                        <el-row :gutter="20">
                            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                                <el-form-item :label="$t('Title')" prop="title">
                                    <el-input v-model="generalSettings.title"></el-input>
                                </el-form-item>
                                <el-form-item :label="$t('Admin Email')" prop="email">
                                    <el-input v-model="generalSettings.email"></el-input>
                                </el-form-item>
                                <el-form-item :label="$t('Timezone')" prop="timezone">
                                    <el-select filterable v-model="generalSettings.timezone" :placeholder="$t('Select Timezone')">
                                        <el-option v-for="zone in getTimeZone" :key="zone.value" :label="zone.label"
                                            :value="zone.value"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item :label="$t('Date Format')" prop="date_format">
                                    <el-select v-model="generalSettings.date_format" :placeholder="$t('Select DateFormat')">
                                        <el-option v-for="dformat in getDateFormats" :key="dformat" :label="dformat"
                                            :value="dformat"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item :label="$t('Time Format')" prop="time_format">
                                    <el-select v-model="generalSettings.time_format" :placeholder="$t('Select TimeFormat')">
                                        <el-option :label="$t('Use 24h clock')" value="HH:mm:ss"></el-option>
                                        <el-option :label="$t('Use 12h clock')" value="h:mm:ss A"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item :label="$t('Language')" prop="language_id">
                                    <el-select v-model="generalSettings.language_id" :placeholder="$t('Select language')">
                                        <el-option v-for="language in languages" :key="language.lang" :label="language.Text"
                                            :value="language.lang"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item :label="$t('Currency')" prop="currency_code">
                                    <el-select v-model="generalSettings.currency_code" :placeholder="$t('Select currency')">
                                        <el-option v-for="currency in getCurrencyList" :key="currency" :label="currency"
                                            :value="currency"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                                <el-card shadow="never">
                                    <el-form-item :label="$t('Logo Upload')" prop="logo_src" class="no-margin">
                                        <el-upload ref="upload" class="avatar-uploader" action="" :on-change="handleChange"
                                            :auto-upload="false" :show-file-list="false" :on-remove="handleRemove"
                                            :before-upload="beforeAvatarUpload">
                                            <img v-if="generalSettings.logo_src" :src="generalSettings.logo_src" class="avatar">
                                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                        </el-upload>
                                    </el-form-item>
                                </el-card>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                                <el-form-item class="no-margin">
                                    <el-button type="primary" @click="submitForm('generalSettings')">{{ $t('Save') }}</el-button>
                                    <router-link tag="el-button" to="/dashboard" class="el-button--cancel">{{ $t('Cancel') }}</router-link>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
            </div>
        </el-col>
    </el-row>
</template>

<script>
    import moment from "moment";
    export default {
        data() {
            return {
                formData: {},
                imageUrl: "",
                generalSettings: {},
                zonelist: moment.tz.names(),
                languages: process.env.KIPAKI_languages,
                labelPosition: "top",
                rules: {
                    email: [{
                        type: "email",
                        message: this.$t('Please input valid email address'),
                        trigger: ["change", "blur"]
                    }]
                }
            };
        },
        computed: {
            getTimeZone() {
                var offsetTmz = [];
                for (var i in this.zonelist) {
                    offsetTmz.push({
                        value: this.zonelist[i],
                        label: "(GMT" +
                            moment.tz(this.zonelist[i]).format("Z") +
                            ") " +
                            this.zonelist[i]
                    });
                }
                return offsetTmz;
            },
            getDateFormats() {
                return process.env.KIPAKI_date_formats;
            },
            getCurrencyList() {
                return process.env.KIPAKI_currency_list;
            }
        },
        mounted() {
            this.generalSettings = JSON.parse(JSON.stringify(this.$store.getters.getConfig("generalSettings")));
            this.formData = new FormData();
        },
        methods: {
            handleRemove(res, file) {
                this.generalSettings.logo_src = null;
            },
            beforeAvatarUpload(file) {
                const isJPG = file.type === "image/jpeg" || file.type === "image/png";
                const isLt2M = file.size / 1024 / 1024 < 2;
                if (!isJPG) {
                    this.$message.error(this.$t('Image type must be of JPG or PNG format'));
                }
                if (!isLt2M) {
                    this.$message.error(this.$t('Image size should not exceed to 2MB'));
                }
                return isJPG && isLt2M;
            },
            handleChange(file) {
                if (this.beforeAvatarUpload(file.raw)) {
                    this.formData.append("logo_src", file.raw);
                    this.generalSettings.logo_src = URL.createObjectURL(file.raw);
                }
            },
            submitForm() {
                for (var key in this.generalSettings) {
                    if (this.generalSettings.hasOwnProperty(key) && key !== "logo_src") {
                        this.formData.append(key, this.generalSettings[key]);
                    }
                }
                request({
                        url: "/general-settings",
                        method: "post",
                        data: this.formData
                    })
                    .then(response => {
                        this.$store.commit('setConfig', {
                            generalSettings: response.data.data
                        });

                        this.$notify({
                            title: this.$t('Success'),
                            message: response.data.message,
                            type: "success",
                            offset: 50
                        });
                        serverBus.$emit('titleChange', this.generalSettings.title);
                        if (localStorage.getItem('lang') !== this.generalSettings.language_id) {
                            localStorage.setItem('lang', this.generalSettings.language_id);
                            location.reload();
                        }
                    })
                    .catch(error => {
                        this.$notify({
                            title: this.$t('Error'),
                            message: error.response.data.message,
                            type: "error",
                            offset: 50
                        });
                    });
            }
        }
    };

</script>



// WEBPACK FOOTER //
// src/components/Layout/GeneralSettings/GeneralSettings.vue